export const MIN_HEIGHT_TO_SHOW_EXPAND = 456;
